import {
  Badge,
  Button,
  Card,
  Flex,
  Grid,
  Group,
  Image,
  NumberFormatter,
  Popover,
  Text
} from '@mantine/core';
import React, { Component } from 'react';
import { FiCalendar, FiGift } from 'react-icons/fi';
import { MdAccountTree } from 'react-icons/md';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getSharepointCdnFileMedia } from '../../utilities';
import { showNotification } from '../../utilities/mantineNotification';
import { TbCircleLetterP } from 'react-icons/tb';

interface CardRedeemProps {
  item: any;
  jenis: string;
}

export default class CardRedeem extends Component<CardRedeemProps> {
  render() {
    return (
      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
        {this.props.jenis === 'avail' ? (
          <Link
            to={`/redeem/${this.props.item.inventoryRewardID}?type=${this.props.item.inventoryRewardPickedID}`}
            style={{
              textDecoration: 'none'
            }}
          >
            <Card shadow="sm" padding="none" radius="md" withBorder>
              <Flex justify={'space-between'}>
                <Group p={'md'}>
                  <div>
                    <Badge
                      color={
                        this.props.jenis === 'avail'
                          ? 'teal'
                          : this.props.jenis === 'waiting'
                          ? 'orange'
                          : this.props.jenis === 'approved'
                          ? 'green'
                          : 'red'
                      }
                      radius={'lg'}
                    >
                      {this.props.jenis === 'avail'
                        ? 'Available'
                        : this.props.jenis}
                    </Badge>

                    <Text fw={800} pt={0} size="sm">
                      {this.props.item.inventoryName}
                    </Text>
                    <Text fw={400} size="sm">
                      {this.props.item?.description.length > 50
                        ? this.props.item.description.substring(0, 50) + '...'
                        : this.props.item.description}
                    </Text>
                  </div>
                </Group>
                <Image
                  src={getSharepointCdnFileMedia(this.props.item.rewardImage)}
                  w={120}
                  h={120}
                  radius="full"
                  style={{ cursor: 'pointer', objectFit: 'contain' }}
                />
              </Flex>

              <div
                style={{
                  padding: '10px',
                  backgroundColor: '#F5F5F5'
                }}
              >
                <Flex justify={'space-between'}>
                  <Flex align="center">
                    <FiCalendar size={20} />
                    <Text size="sm" ml="sm">
                      {getDateFormat(this.props.item.startDate)} -{' '}
                      {getDateFormat(this.props.item.endDate)}
                    </Text>
                  </Flex>
                  <div
                    style={{
                      width: '10px'
                    }}
                  ></div>
                  <Group gap={2}>
                    <TbCircleLetterP size={20} color="orange" />
                    <Text fw={800} size="sm">
                      <NumberFormatter
                        value={Number(this.props.item.redeemPoint)}
                        suffix={` Point${
                          Number(this.props.item.redeemPoint) > 1 ? 's' : ''
                        }`}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                  </Group>
                </Flex>
              </div>
            </Card>
          </Link>
        ) : (
          <Link
            to={`/redeem/${this.props.item.inventoryRewardID}?type=${this.props.item.inventoryRewardPickedID}`}
            style={{
              textDecoration: 'none'
            }}
          >
            <Card shadow="sm" padding="none" radius="md" withBorder>
              <Flex justify={'space-between'}>
                <Group p={'md'}>
                  <div>
                    <Badge
                      color={
                        this.props.jenis === 'avail'
                          ? 'teal'
                          : this.props.jenis === 'waiting'
                          ? 'orange'
                          : this.props.jenis === 'approved'
                          ? 'green'
                          : 'red'
                      }
                      radius={'lg'}
                    >
                      {this.props.jenis === 'avail'
                        ? 'Available'
                        : this.props.jenis}
                    </Badge>

                    <Text fw={800} pt={0} size="sm">
                      {this.props.item.inventoryName}
                    </Text>
                    <Text fw={400} size="sm">
                      {this.props.item?.description.length > 50
                        ? this.props.item.description.substring(0, 50) + '...'
                        : this.props.item.description}
                    </Text>
                  </div>
                </Group>
                <Image
                  src={getSharepointCdnFileMedia(this.props.item.rewardImage)}
                  w={120}
                  h={120}
                  radius="full"
                  style={{ cursor: 'pointer', objectFit: 'contain' }}
                />
              </Flex>

              <div
                style={{
                  padding: '10px',
                  backgroundColor: '#F5F5F5'
                }}
              >
                <Flex justify={'space-between'}>
                  <Flex align="center">
                    <FiCalendar size={20} />
                    <Text size="sm" ml="sm">
                      {getDateFormat(this.props.item.startDate)} -{' '}
                      {getDateFormat(this.props.item.endDate)}
                    </Text>
                  </Flex>
                  <div
                    style={{
                      width: '10px'
                    }}
                  ></div>
                  <Group gap={4}>
                    <TbCircleLetterP size={20} color="orange" />
                    <Text fw={800} size="sm">
                      {this.props.item.redeemPoint} Point
                      {this.props.item.redeemPoint > 1 ? 's' : ''}
                    </Text>
                  </Group>
                </Flex>
              </div>
            </Card>
          </Link>
        )}
      </Grid.Col>
    );
  }
}

function getDateFormat(date: string) {
  return moment(date).format('DD/MM/YYYY');
}
